import styled from '@emotion/styled';
import { TcolorsPaletteFromBO } from '../../types';

export const StyledMenuItems = styled('div')(() => ({
  display: 'flex',
  gap: 32,
  alignItems: 'center',
}));

export const StyledProfileContainer = styled('div')(() => ({
  height: '100%',
  width: '20%',
  padding: 16,
  gap: 16,
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'right',
  fontSize: 16,
  fontWeight: 900,
  textTransform: 'initial',
  cursor: 'pointer',
}));

export const StyledUserAndRewardSection = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  fontFamily: '"RaleWay", "Helvetica", "Arial", sans-serif',
  fontWeight: 700,
  fontSize: 15,
}));

export const StyledRewardSection = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  fontWeight: 'normal',
}));

export const StyledRewardValue = styled('div')(
  ({ colorsPaletteFromBO }: { colorsPaletteFromBO: TcolorsPaletteFromBO }) => ({
    color: colorsPaletteFromBO.main,
    fontWeight: 'bold',
  }),
);

export const StyledPopper = styled('div')(() => ({
  zIndex: 1000,
  position: 'relative',
}));

export const StyledPaper = styled('div')(() => ({
  zIndex: 1001,
  position: 'absolute',
  top: 40,
  left: -264,
  width: 250,
  backgroundColor: 'white',
  boxShadow: '0 3px 10px 0 rgba(112, 112, 112, 0.3)',
}));

export const StyledLink = styled('a')(
  ({ colorsPaletteFromBO }: { colorsPaletteFromBO: TcolorsPaletteFromBO }) => ({
    textDecoration: 'none',
    color: '#4e4e4e',
    fontWeight: 'bold',
    fontSize: 12,
    padding: '8px 16px',
    '& div:first-of-type': {
      width: 30,
    },
    '&:hover': {
      color: 'white',
      textDecoration: 'none',
      backgroundColor: colorsPaletteFromBO.main,
      '& path:first-of-type': {
        fill: `white !important`,
      },
    },
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  }),
);

export const StyledAction = styled('div')(
  ({ colorsPaletteFromBO }: { colorsPaletteFromBO: TcolorsPaletteFromBO }) => ({
    color: '#4e4e4e',
    fontWeight: 'bold',
    fontSize: 12,
    padding: '8px 16px',
    '& div:first-of-type': {
      width: 30,
    },
    '&:hover': {
      color: 'white',
      textDecoration: 'none',
      backgroundColor: colorsPaletteFromBO.main,
      '& path:first-of-type': {
        fill: `white !important`,
      },
    },
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  }),
);
